// TDD - CUSTOM JQUERY
(function($){
  $(document).ready(function(){


    // MAIN DESKTOP NAVIGATION SLIDE OUT NAV
    $('.js_open_close_main_navigation_desktop').click(function() {
      $('.header_desktop_slide_panel_main').toggleClass('js_slide_main_navigation_panel_right');
    });


    // MOBILE DESKTOP NAVIGATION SLIDE OUT NAV
    $('.js_open_close_main_navigation_mobile').click(function() {
      $('.header_desktop_slide_panel_main').toggleClass('js_slide_main_navigation_panel_right');
    });


    // MAIN DESKTOP NAVIGATION SLIDE OUT NAV
    $('.js_toggle_designers_navigation_desktop').click(function() {
      $('.header_desktop_slide_panel_sub').toggleClass('js_slide_main_navigation_panel_right');
    });


    // SEARCH DROPDOWN
    $('.js_search_toggle').click(function() {
      $('.search_dropdown_container').slideToggle('fast');
      $('.search_icon svg').toggleClass('toggle_visibility');
    });


    // CONTACT PAGE ACCORDIAN
    // Drop down + arrow sections.
    $('.js_drop_panel_input').click(function() {
      $(this).closest('.drop_panel_defaults').find('.js_drop_panel_output').slideToggle('fast');
      $(this).find('svg').toggleClass('js_contact_rotate_small_arrow');
    });


    // SHOW KLAVIYO PRODUCT SOLD OUT FORM
    // You have to use document.on click to get it to work after an ajax call because it's not in the DOM
    // https://stackoverflow.com/questions/17715274/jquery-click-function-doesnt-work-after-ajax-call
    $(document).on('click', '.js_klaviyo_product_form_visible', function(){
        $('.klaviyo_product_form').toggleClass('js_klaviyo_product_form_visibility');
    });


    // Written directly on the page so it doesn't load on every other page.
    // $('.product_slick_slider').slick({
    //   slidesToShow: 6,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   autoplaySpeed: 3000,
    //   // the magic
    //   responsive: [{
    //       breakpoint: 1100,
    //       settings: {
    //         slidesToShow: 4
    //       }
    //     }, {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow: 2
    //       }
    //     }]
    // });

  // EXTRA WISHLIST FUNCTIONALITY
  // CHECK IF THE HEART BUTTON WAS CLICKED
  // Then check if the page to see if there is any .active_heart classes
  // If there is add a class to the heart icon in the top nav.
  // If it's clicked and there is no .active_heart classes on the page remove the top nav class.
    $('.js_wishlist_button_click').click(function() {
      if ($(".active_heart").length > 0) {
        $(".heart_icon").addClass('active_wishlist');
        }
        else if ($(".active_heart").length < 1) {
        $(".heart_icon").removeClass('active_wishlist');
        }
    });

    // If you access a page direct check it.
    if ($(".active_heart").length > 0) {
      $(".heart_icon").addClass('active_wishlist');
      }
      else if ($(".active_heart").length < 1) {
      $(".heart_icon").removeClass('active_wishlist');
      }












  }); // Close Document Ready






})(jQuery);